<template>
  <div class="follow-user__box">
    <a :href="`/u/${screenName}`" class="follow-user__link">
      <div class="follow-user__icon">
        <AccountIconWh56 :image-url="iconUrl" />
      </div>
      <div class="follow-user__info-area">
        <div class="follow-user__name">
          {{ nickname }}
        </div>
        <div
          v-if="showBirthday && isBirthday"
          class="follow-user__birthday--today"
        >
          本日が誕生日
        </div>
        <div v-if="showBirthday && !isBirthday" class="follow-user__birthday">
          {{ `誕生日 ${birthdayMonth}月${birthdayDate}日` }}
        </div>
      </div>
    </a>
    <button class="follow-user__button" @click="onClickFollowingButton">
      フォロー中
    </button>
  </div>
</template>

<script>
import AccountIconWh56 from '../../../atoms/account_icons/AccountIconWh56.vue'

export default {
  components: {
    AccountIconWh56
  },
  props: {
    userId: {
      type: Number,
      require: true,
      default: 0
    },
    iconUrl: {
      type: String,
      require: true,
      default: ''
    },
    nickname: {
      type: String,
      require: true,
      default: ''
    },
    screenName: {
      type: String,
      require: true,
      default: ''
    },
    birthdayDisplayable: {
      type: Boolean,
      require: true,
      default: false
    },
    birthdayMonth: {
      type: Number,
      require: true,
      default: 0
    },
    birthdayDate: {
      type: Number,
      require: true,
      default: 0
    }
  },
  computed: {
    showBirthday() {
      return this.birthdayDisplayable && this.birthdayMonth && this.birthdayDate
    },
    isBirthday() {
      const today = new Date()
      return (
        today.getDate() === this.birthdayDate &&
        today.getMonth() === this.birthdayMonth - 1
      ) // getMonthは0-11で月を返すので-1して比較する
    }
  },
  methods: {
    onClickFollowingButton() {
      this.$emit(
        'click-following-button',
        this.nickname,
        this.screenName,
        this.userId
      )
    }
  }
}
</script>
<style lang="scss" scoped>
%birthday {
  @include bg-settings(
    '../../../../../../images/icons/birthday.svg',
    $white,
    10px,
    14px
  );
  padding-left: 14px;
  margin-top: 4px;
  text-align: left;
  @extend %minimal;
}

.follow-user {
  &__box {
    background-color: $white;
    padding: 8px 16px;
    display: flex;
    gap: 16px;

    &:not(:last-child) {
      border-bottom: solid 1px $gray-2;
    }
  }

  &__link {
    display: flex;
    gap: 16px;
    width: 100%;
  }

  &__info-area {
    display: flex;
    flex-direction: column;
    align-self: center;
  }

  &__name {
    @extend %caption-bold;
    color: $black;
    text-align: left;
    word-break: break-word;
  }

  &__birthday {
    @extend %birthday;

    &--today {
      @extend %birthday;
      @include bg-settings(
        '../../../../../../images/icons/birthday-primary.svg',
        $white,
        10px,
        14px
      );
      color: $primary;
    }
  }

  &__button {
    height: fit-content;
    padding: 8px 16px;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 1.6;
    cursor: pointer;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    color: $primary;
    border-radius: 100px;
    border: solid 1px $primary;
    align-self: center;
    margin-left: auto;
    min-width: 94px;

    @media (hover: hover) {
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>
